var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-trend-query-view"},[_c('StockTrendQuery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }